import React, { Component } from 'react';
import cn from 'classnames';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { string, node, object, func, oneOfType } from 'prop-types';
import LayoutCol from './LayoutCol';
import LayoutLeftCol from './LayoutLeftCol';
import LayoutRightCol from './LayoutRightCol';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import { connect } from 'react-redux';

class Layout extends Component {
  static propTypes = {
    children: node.isRequired,
    formattedTitle: string,
    title: string,
    innerRef: oneOfType([object, func, string]),
  };

  static Col = LayoutCol;
  static LeftCol = LayoutLeftCol;
  static RightCol = LayoutRightCol;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {
      webmaster: {
        profile: { theme },
      },
      children,
      className,
      formattedTitle,
      title,
      innerRef,
      ...rest
    } = this.props;

    return (
      <div ref={innerRef} className={cn(`container`, className)} {...rest}>
        {title && <Helmet title={title} />}
        {formattedTitle && (
          <FormattedMessage id={formattedTitle}>
            {(title) => <Helmet title={title} />}
          </FormattedMessage>
        )}
        {formattedTitle && (
          <h1 className="content-title">
            <FormattedMessage id={formattedTitle} />
          </h1>
        )}
        <div className="row">{children}</div>
      </div>
    );
  }
}

const mapStateToProps = ({ webmaster }) => ({
  webmaster,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
